<template lang="pug">
  .keyboard-shortcuts-info
    | Pressione a tecla ENTER p/ Continuar
    br
    | Pressione a tecla ESC p/ Fechar
</template>

<script>
export default {
  name: 'KeyboardShortcutsInfo',
  props: {
    // Opcional: permitir personalizar o texto
    enterText: {
      type: String,
      default: 'Pressione a tecla ENTER p/ Continuar'
    },
    escText: {
      type: String,
      default: 'Pressione a tecla ESC p/ Fechar'
    }
  }
}
</script>

<style scoped lang="scss">
.keyboard-shortcuts-info {
  font-size: 14px;
  color: #666;
  text-align: right;
  margin-top: 15px;
  padding: 8px;
  background-color: #f8f9fa;
  border-radius: 4px;
  border: 1px solid #e9ecef;
  font-style: italic;
}
</style>
